module.exports = __webpack_public_path__ + "static/media/goto_shop_mobile_degradado.5d0ac4f5.png";